import React, { useState, useEffect } from 'react';

const GalleryStats = () => {
  const [stats, setStats] = useState({
    totalPhotos: 0,
    categories: 0,
    activeYear: new Date().getFullYear(),
    photographers: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      // Essayer d'abord l'API dédiée aux statistiques
      const statsResponse = await fetch('http://localhost:8000/api/public/gallery-stats');
      
      if (statsResponse.ok) {
        const statsData = await statsResponse.json();
        if (statsData.success) {
          setStats({
            totalPhotos: statsData.stats.total_photos,
            categories: statsData.stats.categories,
            activeYear: statsData.stats.active_year,
            photographers: statsData.stats.photographers > 10 ? '10+' : statsData.stats.photographers
          });
          return;
        }
      }
      
      // Fallback : utiliser l'API des images pour calculer les stats
      const response = await fetch('http://localhost:8000/api/public/gallery-images');
      const data = await response.json();
      
      if (data.success) {
        const images = data.data;
        const categoriesCount = Object.keys(data.categories).length;
        const uniquePhotographers = new Set(images.map(img => img.photographer)).size;
        
        setStats({
          totalPhotos: images.length,
          categories: categoriesCount,
          activeYear: new Date().getFullYear(),
          photographers: uniquePhotographers > 10 ? '10+' : uniquePhotographers
        });
      }
    } catch (error) {
      console.error('Erreur lors du chargement des statistiques:', error);
      // Valeurs par défaut en cas d'erreur
      setStats({
        totalPhotos: 3,
        categories: 5,
        activeYear: new Date().getFullYear(),
        photographers: '10+'
      });
    }
  };

  const statsData = [
    {
      value: stats.totalPhotos,
      label: 'Photos totales',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      value: stats.categories,
      label: 'Catégories',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      value: stats.activeYear,
      label: 'Année active',
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      value: stats.photographers,
      label: 'Photographes',
      color: 'text-red-600',
      bgColor: 'bg-red-50'
    }
  ];

  return (
    <div className="container mx-auto px-6 -mt-8 mb-12 relative z-10">
      <div className="bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            Notre galerie en chiffres
          </h2>
          <p className="text-gray-600 text-justify">
            Découvrez l'activité photographique de notre communauté
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {statsData.map((stat, index) => (
            <div 
              key={index}
              className={`text-center p-6 rounded-xl ${stat.bgColor} transition-transform hover:scale-105 duration-300`}
            >
              <div className={`text-4xl md:text-5xl font-bold ${stat.color} mb-2`}>
                {stat.value}
              </div>
              <div className="text-gray-700 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryStats;